import { Location } from '../../components/NewSearch/NewSearchLocations/types';

export const getChosenLocationNames = (
  locations: Location[] = [],
  locationIds: string[] = []
) => {
  const locationsIdsSet = new Set(locationIds);
  return locations.reduce((acc, location) => {
    if (locationsIdsSet.has(location.id)) {
      acc.push(location.name?.trim());
    }
    return acc;
  }, []);
};
